import { DestinationKeyType, DestinationType } from 'types/Destination';

export const DestinationTypeDescription = {
	[DestinationType.CACC]: 'Conta Corrente',
	[DestinationType.SVGS]: 'Conta poupança',
	[DestinationType.TRAN]: 'Conta de pagamentos',
	[DestinationType.SLRY]: 'Conta salário',
};

export const DestinationKeyTypeDescription = {
	[DestinationKeyType.CPF]: 'CPF',
	[DestinationKeyType.CNPJ]: 'CNPJ',
	[DestinationKeyType.EMAIL]: 'E-mail',
	[DestinationKeyType.PHONE]: 'Telefone',
	[DestinationKeyType.EVP]: 'Aleatória',
};
